// extracted by mini-css-extract-plugin
module.exports = {"Paragraph":"mXNSP"};